var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg5 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5,
    transform: "translate(-98 -50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 16,
    height: 16,
    transform: "translate(98 50)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(100 52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    "data-name": "Group 826",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(-1 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M8.037,12H3.964A3.964,3.964,0,0,1,0,8.037V3.963A3.964,3.964,0,0,1,3.964,0H8.037A3.964,3.964,0,0,1,12,3.963V8.037A3.964,3.964,0,0,1,8.037,12",
    transform: "translate(0 0)",
    fill: "#fcd541"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M11.7,5.052a.734.734,0,0,0,.586-1.176A2.728,2.728,0,0,0,10.1,2.79H6.031A2.728,2.728,0,0,0,3.852,3.877a.734.734,0,0,0,.586,1.176Z",
    transform: "translate(-2.067 -1.558)",
    fill: "#ffe183"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M12.434,17.407a2.321,2.321,0,0,1-2.321,2.321H6.04a2.321,2.321,0,0,1-2.321-2.321.624.624,0,0,1,.624-.624H11.81a.624.624,0,0,1,.624.624",
    transform: "translate(-2.076 -9.37)",
    fill: "#434849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M9.374,19.087A.909.909,0,0,0,9,19.179a.449.449,0,0,1-.4,0,.911.911,0,0,0-.374-.092.921.921,0,0,0-.932.884v.855a1.5,1.5,0,0,0,3.01,0v-.855a.921.921,0,0,0-.932-.884",
    transform: "translate(-4.074 -10.656)",
    fill: "#f7473d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M7.427,9.241A1.329,1.329,0,1,0,6.1,10.569,1.329,1.329,0,0,0,7.427,9.241",
    transform: "translate(-2.663 -4.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M7.6,10.07a.672.672,0,1,0-.672.672A.672.672,0,0,0,7.6,10.07",
    transform: "translate(-3.493 -5.247)",
    fill: "#434849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M17.1,8.269a2.1,2.1,0,1,0-2.1,2.1,2.1,2.1,0,0,0,2.1-2.1",
    transform: "translate(-7.203 -3.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M17.37,9.579a1.061,1.061,0,1,0-1.061,1.061A1.061,1.061,0,0,0,17.37,9.579",
    transform: "translate(-8.513 -4.756)",
    fill: "#434849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M12.69,16.782v.381A1.092,1.092,0,0,1,11.6,18.255H7.013a1.092,1.092,0,0,1-1.091-1.091v-.381Z",
    transform: "translate(-3.306 -9.37)",
    fill: "#f0f2f2"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg5, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/5.4ca9edf6.svg";
export { ForwardRef as ReactComponent };